import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Ignore known browser-translation / extension DOM errors
    if (
      error?.name === 'NotFoundError' &&
      error?.message?.includes('removeChild')
    ) {
      return null; // don't crash
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress DOM manipulation errors caused by browser translate/extensions
    if (
      error?.name === 'NotFoundError' ||
      error?.message?.includes('removeChild') ||
      error?.message?.includes('insertBefore')
    ) {
      console.warn('DOM error suppressed (likely browser extension/translate):', error.message);
      return;
    }
    console.error('Application error:', error, errorInfo);
  }

  handleReload = () => {
    // Clear service worker cache and reload
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] p-4">
          <div className="max-w-md w-full bg-white border border-red-200 rounded-2xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-2">Bir Hata Oluştu</h2>
            <p className="text-sm text-[#595959] mb-6">
              Uygulama beklenmedik bir hata ile karşılaştı. Lütfen sayfayı yenileyin.
            </p>
            <button
              onClick={this.handleReload}
              className="px-6 py-2.5 bg-[#2563EB] text-white rounded-lg hover:bg-[#1E4ED8] transition font-medium"
              data-testid="error-reload-btn"
            >
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
